var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRefreshRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F31919",
    d: "M7.441 12.553A4.748 4.748 0 0 1 7.406 12c0-2.517 2.077-4.594 4.594-4.594 1.174 0 2.274.474 3.082 1.212l-.405.412a.36.36 0 0 0-.092.352c.042.12.14.211.267.24.071.013 2.396.762 2.248.733.188.062.467-.138.415-.415l-.5-2.506a.353.353 0 0 0-.245-.267.351.351 0 0 0-.345.092l-.345.337A5.996 5.996 0 0 0 12 6c-3.298 0-6 2.702-6 6v.014c0 .198.01.351.02.469a.352.352 0 0 0 .28.313l.723.144a.352.352 0 0 0 .418-.387zM17.701 11.204l-.724-.148a.352.352 0 0 0-.42.387c.026.205.037.405.037.557 0 2.517-2.077 4.594-4.594 4.594a4.579 4.579 0 0 1-3.082-1.219l.405-.405a.36.36 0 0 0 .092-.352.368.368 0 0 0-.267-.24c-.071-.013-2.396-.762-2.248-.733a.344.344 0 0 0-.316.099.35.35 0 0 0-.099.316l.5 2.482c.027.127.119.232.245.267a.338.338 0 0 0 .345-.091l.337-.338A6.02 6.02 0 0 0 12 18c3.298 0 6-2.702 6-6v-.021c0-.156-.006-.309-.019-.461a.351.351 0 0 0-.28-.314z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefreshRed);
export default __webpack_public_path__ + "static/media/ic_refresh_red.61680ce31bd786900537bf5cdee6fa2e.svg";
export { ForwardRef as ReactComponent };